export enum ReviewSizeAnalysisType {
  MULTI_SIZE = 1,
  SINGLE_SIZE = 2,
}

export type SizeReviewAnalysisResponse = {
  size_info: {
    total_count: number;
    analysis_type: ReviewSizeAnalysisType;
    size_analysis: { name: string; percent: number }[];
  } | null;
};
